import clsx from 'clsx'
import { FC } from 'react'

import { useGlobalState } from '@pepper/ui'

import Writers from 'assets/images/writers.png'
import {
  MARKETPLACE_KNOW_MORE_URL,
  BOOK_A_DEMO_URL,
} from 'utils/constants/website_urls'

import styles from './MarketplaceStagesBanner.module.css'

type Props = {
  className?: string
}

const MarketplaceStagesBanner: FC<Props> = ({ className }) => {
  const { viewport } = useGlobalState()

  return (
    <div className={clsx(className, styles.main)}>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.bannerStateText}>TOP 3% TALENT</div>
          <div className={styles.title}>Hire your dream content team</div>
        </div>
        <div className={styles.buttonWrapper}>
          <a
            className={clsx(styles.primaryButton, styles.button)}
            target="_blank"
            rel="noreferrer"
            href={BOOK_A_DEMO_URL}
          >
            Contact Sales
          </a>
          <a
            className={clsx(styles.secondaryButton, styles.button)}
            href={MARKETPLACE_KNOW_MORE_URL}
            target="_blank"
            rel="noreferrer"
          >
            Know More
          </a>
        </div>
      </div>

      {viewport === 'lg' && (
        <div className={styles.writersImageWrapper}>
          <div className={styles.imagesContainer}>
            <img src={Writers} alt="writers" />
          </div>
        </div>
      )}
    </div>
  )
}

export default MarketplaceStagesBanner
